export default __webpack_public_path__ + "static/media/LOGOTIPO 12.3e254c4a.png";